import _extends from "@babel/runtime/helpers/extends";
import _slicedToArray from "@babel/runtime/helpers/slicedToArray";
import React, { useState, useLayoutEffect, useRef } from 'react';
import { IntlProvider, injectIntl } from 'react-intl-next';
import { Shortcut } from '@atlaskit/media-ui';
import { useAnalyticsEvents } from '@atlaskit/analytics-next';
import { fireAnalytics } from './analytics';
import { createModalEvent } from './analytics/events/screen/modal';
import { createClosedEvent } from './analytics/events/ui/closed';
import { List } from './list';
import { Content } from './content';
import { Blanket, SidebarWrapper } from './styleWrappers';
import { start } from 'perf-marks';
import { mediaViewerPopupClass } from './classnames';
import ScrollLock from 'react-scrolllock';
import FocusLock from 'react-focus-lock';
var MediaViewerComponent = function MediaViewerComponent(_ref) {
  var featureFlags = _ref.featureFlags,
    items = _ref.items,
    extensions = _ref.extensions,
    contextId = _ref.contextId,
    innerRef = _ref.innerRef,
    _onClose = _ref.onClose,
    selectedItem = _ref.selectedItem,
    intl = _ref.intl,
    viewerOptions = _ref.viewerOptions;
  var _useState = useState(false),
    _useState2 = _slicedToArray(_useState, 2),
    isSidebarVisible = _useState2[0],
    setIsSidebarVisible = _useState2[1];
  var _useState3 = useState(),
    _useState4 = _slicedToArray(_useState3, 2),
    selectedIdentifier = _useState4[0],
    setSelectedIdentifier = _useState4[1];
  var _useAnalyticsEvents = useAnalyticsEvents(),
    createAnalyticsEvent = _useAnalyticsEvents.createAnalyticsEvent;
  var createAnalyticsEventRef = useRef(createAnalyticsEvent);
  createAnalyticsEventRef.current = createAnalyticsEvent;
  useLayoutEffect(function () {
    fireAnalytics(createModalEvent(), createAnalyticsEventRef.current);
    start('MediaViewer.SessionDuration');
  }, []);
  var defaultSelectedItem = selectedItem || items[0];
  var renderSidebar = function renderSidebar() {
    var sidebarSelectedIdentifier = selectedIdentifier || defaultSelectedItem;
    if (sidebarSelectedIdentifier && isSidebarVisible && extensions && extensions.sidebar) {
      return /*#__PURE__*/React.createElement(SidebarWrapper, {
        "data-testid": "media-viewer-sidebar-content"
      }, extensions.sidebar.renderer(sidebarSelectedIdentifier, {
        close: function close() {
          return setIsSidebarVisible(!isSidebarVisible);
        }
      }));
    }
  };
  var content = /*#__PURE__*/React.createElement("div", {
    ref: innerRef
  }, /*#__PURE__*/React.createElement(Blanket, {
    "data-testid": "media-viewer-popup"
    // eslint-disable-next-line @atlaskit/ui-styling-standard/no-classname-prop -- Ignored via go/DSP-18766
    ,
    className: mediaViewerPopupClass
  }, /*#__PURE__*/React.createElement(Shortcut, {
    code: 'Escape',
    handler: function handler() {
      fireAnalytics(createClosedEvent('escKey'), createAnalyticsEventRef.current);
      _onClose && _onClose();
    }
  }), /*#__PURE__*/React.createElement(Content, {
    isSidebarVisible: isSidebarVisible,
    onClose: function onClose(_e, analyticsEvent) {
      var _analyticsEvent$paylo;
      if ((analyticsEvent === null || analyticsEvent === void 0 || (_analyticsEvent$paylo = analyticsEvent.payload) === null || _analyticsEvent$paylo === void 0 ? void 0 : _analyticsEvent$paylo.actionSubject) === 'button') {
        fireAnalytics(createClosedEvent('button'), createAnalyticsEventRef.current);
      }
      _onClose && _onClose();
    }
  }, /*#__PURE__*/React.createElement(List, {
    defaultSelectedItem: defaultSelectedItem || items[0],
    items: items,
    onClose: _onClose,
    extensions: extensions,
    onNavigationChange: setSelectedIdentifier,
    onSidebarButtonClick: function onSidebarButtonClick() {
      return setIsSidebarVisible(!isSidebarVisible);
    },
    isSidebarVisible: isSidebarVisible,
    contextId: contextId,
    featureFlags: featureFlags,
    viewerOptions: viewerOptions
  })), renderSidebar()));
  return intl ? content : /*#__PURE__*/React.createElement(IntlProvider, {
    locale: "en"
  }, content);
};
var MediaViewerWithRef = /*#__PURE__*/React.forwardRef(function (props, ref) {
  return /*#__PURE__*/React.createElement(MediaViewerComponent, _extends({}, props, {
    innerRef: ref
  }));
});
var MediaViewerWithScrollLock = function MediaViewerWithScrollLock(props) {
  return /*#__PURE__*/React.createElement(FocusLock, {
    autoFocus: true
  }, /*#__PURE__*/React.createElement(ScrollLock, null), /*#__PURE__*/React.createElement(MediaViewerWithRef, props));
};
export var MediaViewer = injectIntl(MediaViewerWithScrollLock, {
  enforceContext: false
});